import { Switch } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../../contentConstants';
import { PageBreakRow } from '../../../surveys/PageBreakRow';
import { DraggableHeaderRow } from './DraggableHeaderRow';
import { IPageFlowElementDesignRowProps } from './DraggablePageFlowElementRow';
import { DraggablePageFlowElementRow2 } from './DraggablePageFlowElementRow2';

const SwitchWrapper = styled.div`
	text-align: right;
	display: flex;
	justify-content: right;
	align-items: center;
	margin-bottom: 20px;
	height: 41px;
`;
SwitchWrapper.displayName = 'SwitchWrapper';

const SwitchContainer = styled.b`
	position: absolute;
	right: 0px;
	top: 31px;
`;
SwitchContainer.displayName = 'SwitchContainer';

const ColumnNameWrapper = styled.div`
	padding-top: 20px;
`;
ColumnNameWrapper.displayName = 'ColumnNameWrapper';

export interface IPageBreakDesignRowProps extends IPageFlowElementDesignRowProps {
	pageNumber: number;
	totalPages: number;
	canAccessRandomizedItems: boolean;
	pageFlowElementsExist: boolean;
	expanded: boolean;
	randomized: boolean;
	OnRandomizeChange: (sequenceStart: number, isSwitchOn: boolean) => void;
}

export const DraggablePageBreakRow2 = (props: IPageBreakDesignRowProps) => {
	const {
		canAccessRandomizedItems,
		element,
		expanded,
		randomized,
		pageNumber,
		totalPages,
		pageFlowElementsExist,
		pageFlowValidationHelper,
	} = props;
	const warnings = pageFlowValidationHelper.PropertyWarnings(element.surveyElementId);
	const errors = pageFlowValidationHelper.PropertyErrors(element.surveyElementId);

	return (
		<DraggablePageFlowElementRow2
			element={props.element}
			index={props.index}
			pageFlowValidationHelper={props.pageFlowValidationHelper}
			onEdit={props.onEdit}
			onDelete={props.onDelete}
		>
			<>
				<PageBreakRow pageNumber={pageNumber} totalPages={totalPages} propertyWarnings={warnings} propertyErrors={errors} />
				{canAccessRandomizedItems && (
					<SwitchWrapper>
						<SwitchContainer>
							<Switch
								text={ContentConstants.LOGIC_AND_LAYOUT.RANDOMIZE_SWITCH_TEXT}
								textwidth='200px'
								checked={element.isRandomized ?? false}
								onChange={(event: any) => props.OnRandomizeChange(props.element.sequence || 0, event.target.checked)}
							/>
						</SwitchContainer>
					</SwitchWrapper>
				)}
				{getColumnNames(pageFlowElementsExist, expanded, randomized)}
			</>
		</DraggablePageFlowElementRow2>
	);
};

const getColumnNames = (pageFlowElementsExist: boolean, expanded: boolean, randomized: boolean) => {
	return (
		<ColumnNameWrapper>
			<DraggableHeaderRow
				pageFlowElementsExist={pageFlowElementsExist}
				expanded={expanded}
				randomized={randomized}
				showLastHeader={false}
			/>
		</ColumnNameWrapper>
	);
};
